import { defineStore } from 'pinia'
import { ref, reactive } from 'vue'
import { customAlphabet } from 'nanoid'

const generateUrlSafeToken = customAlphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789', 21)

export const useAppStore = defineStore('peepshow', () => ({
    generateUrlSafeToken,
    userId: ref(generateUrlSafeToken()),
    userSecret: ref(generateUrlSafeToken()),
    taped: ref(false),
    pendingTxs: ref({}),
    expansionPanels: ref({
        uploadTool: [1]
    }),
    dev: ref({
        translucentTapes: false
    }),
    tours: ref({
        app: {
            skip: false,
            enabled: false,
            shownOn: undefined,
            lastStep: undefined,
            active: false
        },
    }),
    helpers: ref({
        app: {
            shownSteps: []
        }
    }),
    language: ref('en'),
    theme: ref('light'),
    faq: ref({}),
    form: ref({
        id: generateUrlSafeToken(),
    }),
    optionsExpansionPanel: ref(),
    currentShowId: ref(),
    showMetadata: ref({}),
    uploaded: ref([]),
    pip: reactive({
        x: 0,
        y: 0,
        dragging: false,
        offsetX: 0,
        offsetY: 0
    }),
    pipDisabled: ref(false),
    videoStatsEnabled: ref(false),
    jobId: ref(),
    nextSerial: ref(),
    featureFlags: ref({}),
    warningOverlay: ref(true),
}),
    {
        persist: {
            debug: false,
        }
    }
)